import React, { Component } from "react";
import { ScrollView, View } from "react-native";
import Text from "../components_v2/TextFont";
import { translate } from "../locales/translate";
import Theme from "../argon-ui/Theme";
import PropTypes from "prop-types";
import { faCalendarDay, faClock } from "../../assets/consts/faCharCodes";
import InputBase from "../nativeBase-ui/InputBase";
import Select from "../nativeBase-ui/Select";
import { getDir } from "../util";

const expireUnitOptions = ["day", "hour"];

/**@augments{Component<Props,state>} */
class GuestExpirePicker extends Component {
  static propTypes = {
    expireValue: PropTypes.number,
    expireUnit: PropTypes.oneOf(expireUnitOptions),
    expireValueIsValid: PropTypes.bool,
    onValueChange: PropTypes.func,
    onUnitChange: PropTypes.func,
  };
  constructor(props) {
    super(props);

    let { expireValue, expireUnit } = this.props;
    this.state = {
      expireValue: expireValue || 0,
      expireUnit: expireUnit || expireUnitOptions[0],
    };
  }

  handleValueChange = (val) => {
    var _val = Number(val);
    if (!Number.isNaN(_val)) {
      _val = Math.floor(_val);
      this.setState(
        {
          expireValue: _val,
        },
        () => {
          this.props.onValueChange && this.props.onValueChange(_val);
        }
      );
    }
  };

  handleOnUnitChange = (unit) => {
    this.setState(
      {
        expireUnit: unit,
      },
      () => {
        this.props.onUnitChange && this.props.onUnitChange(unit);
      }
    );
  };

  render() {
    return (
      <View style={{ padding: 5 }}>
        <Text style={{ color: Theme.COLORS.MUTED }}>
          {translate("user.guestExpireSummary", {
            expireValue: this.state.expireValue,
            expireUnit: translate(`app.${this.state.expireUnit}`),
          })}
        </Text>
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: 10,
            direction: getDir(),
          }}
        >
          <InputBase
            bg={Theme.COLORS.LIGHT_MAIN}
            containerStyle={{ width: 100 }}
            inputStyle={{ height: 40 }}
            keyboardType="numeric"
            isInvalid={!this.props.expireValueIsValid}
            onChangeText={(txt) => {
              this.handleValueChange(txt);
            }}
            value={this.state.expireValue.toString()}
            icon={this.state.expireUnit === "day" ? faCalendarDay : faClock}
          />
          <ScrollView style={{ marginHorizontal: 10 }}>
            <Select
              data={expireUnitOptions.map((v) => {
                return { value: v, label: translate(`app.${v}`) };
              })}
              value={this.state.expireUnit || expireUnitOptions[0]}
              onChangeText={(value, index, data) => {
                this.handleOnUnitChange(value);
              }}
            />
          </ScrollView>
        </View>
      </View>
    );
  }
}

export default GuestExpirePicker;
